// src/components/BookToc.jsx
import React from "react";
import ChapterCardList from "./ChapterCardList";

// Eski props'ları bozmayalım: data yoksa bookmarks'ı kullanır.
export default function BookToc({ data = [], bookmarks = [] }) {
  const items = Array.isArray(data) && data.length
    ? data
    : (Array.isArray(bookmarks) ? bookmarks : []);

  if (!items.length) {
    return <div className="text-darkfume small">Kayıt yok.</div>;
  }

  return <ChapterCardList data={items} />;
}
